type VWOActivateCommand = ["activate", { virtualPageUrl: string }];
type VWOLoadedCommand = ["onVWOLoaded", () => void, { count: number }];
type VWOCommand = VWOActivateCommand | VWOLoadedCommand;
type VWOWindow = Window & { VWO?: VWOCommand[] };

const getVWOQueue = (): VWOCommand[] => {
  const windowWithVWO = window as VWOWindow;
  if (!windowWithVWO.VWO) {
    windowWithVWO.VWO = [];
  }
  return windowWithVWO.VWO;
};

export const loadVWO = (url: string) => {
  // Skip if VWO is disabled via NEXT_PUBLIC_VWO_ENABLED in Terraform
  if (process.env.NEXT_PUBLIC_VWO_ENABLED !== 'true') return;

  // Trigger VWO virtual page load
  // https://developers.vwo.com/reference/trigger-virtual-page-load
  // For Split URL tests, VWO needs the full URL to recognize the variation page.
  getVWOQueue().push(["activate", { virtualPageUrl: new URL(url, window.location.origin).href }]);
};

export const whenVWOLoaded = (cb: () => void) => {
  // Skip if VWO is disabled via NEXT_PUBLIC_VWO_ENABLED in Terraform
  if (process.env.NEXT_PUBLIC_VWO_ENABLED !== 'true') return;

  getVWOQueue().push(["onVWOLoaded", cb, { count: 1 }]);
};
